export default __webpack_public_path__ + "static/media/flowers-no-1.f38739f9.mid";